import { z } from "zod";
import {
  YEAR_OF_COLLABORATION,
  GEO_REGION_ID,
  SCHOOL_NAME,
  ACCOUNT_TYPE,
  SCHOOL_TIER,
  STATE,
  CITY,
  SKU,
  NO_OF_WORK_STATIONS,
  NO_OF_FACULTY_DAYS,
} from "../consts";

export const schema = z.object({
  [YEAR_OF_COLLABORATION]: z.string().optional(),
  [GEO_REGION_ID]: z.string().optional(),
  [SCHOOL_NAME]: z.string().optional(),
  [ACCOUNT_TYPE]: z.string().optional(),
  [SCHOOL_TIER]: z.string().optional(),
  [STATE]: z.string().optional(),
  [CITY]: z.string().optional(),
  [SKU]: z.string().optional(),
  [NO_OF_WORK_STATIONS]: z.string().optional(),
  [NO_OF_FACULTY_DAYS]:  z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
